import { createClient } from '@supabase/supabase-js'

// 公開ダッシュボード専用のSupabaseクライアント
// 管理者向けのセッションと分離するため、別のインスタンスを作成
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'http://127.0.0.1:54321'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'

export const supabasePublic = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false, // 自動リフレッシュを無効化
    persistSession: false,   // セッション保存を無効化
    detectSessionInUrl: false, // URLからのセッション検出を無効化
    storage: {
      // カスタムストレージを使用して、メインのセッションと分離
      getItem: (key: string) => {
        return localStorage.getItem(`supabase-public.${key}`)
      },
      setItem: (key: string, value: string) => {
        localStorage.setItem(`supabase-public.${key}`, value)
      },
      removeItem: (key: string) => {
        localStorage.removeItem(`supabase-public.${key}`)
      },
    },
  },
})